import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";
import {toInt} from "@glidejs/glide/src/utils/unit";

//@todo move sticky offset to be a setting defined in the data attribute markup.
export default class ScrollToBehaviour extends AbstractDataAttributeBehaviour {

    attrSelectors = {
        container :'data-scroll-to',
        offset: 'data-scroll-to-offset'
    };

    getContainerSelector()
    {
        return '[' + this.attrSelectors.container + ']';
    }

    initContainer(container)
    {

        let scrollToSelector = container.getAttribute(this.attrSelectors.container);

        container.addEventListener('click', (e) => {
            e.preventDefault();

            let stickyOffset = this.getStickyOffset(container);
            let element = document.querySelector(scrollToSelector);
            let to = this.getOffsetTop(element);

            this.scrollTo((to - stickyOffset), 500);
        });
    }

    getOffsetTop(element) {
        if (!element) return 0;
        return this.getOffsetTop(element.offsetParent) + element.offsetTop;
    };

    getStickyOffset(container) {
        if (container.getAttribute(this.attrSelectors.offset)) return toInt(container.getAttribute(this.attrSelectors.offset));

        let stickyNav = document.querySelector('[data-sticky-nav-container ]');
        if(!stickyNav) stickyNav = document.querySelector('[data-cruise-details-tab-container]');
        if(!stickyNav) stickyNav = document.querySelector('.site-navigation');
        return stickyNav.classList.contains('stick-to-top') ? stickyNav.clientHeight : stickyNav.clientHeight * 2;
    }
    scrollTo(to, duration)
    {
        clearInterval(window.pageScroll); //clear any existing scrolls
        //Check where we want to scroll to and ensure value is not outside page bounds
        if(to < 0) to = 0;
        if(to > (document.body.scrollHeight - window.height)) to = document.body.scrollHeight - window.height;

        if (duration <= 0) {
            window.scrollTo(window.scrollX, to);
            return;
        }

        let perTick = (to - window.scrollY) / duration * 10; //calculate how many pixels need to be moved every 10ms
        let range = perTick < 0 ? perTick *-1: perTick;

        window.pageScroll = setInterval(() => {
            window.scrollTo(window.scrollX, window.scrollY + perTick);

            //range is used to check if page scroll position is within 1 tick of pixels, and if so we move the remaining pixels to prevent any rounding errors
            if (window.scrollY <= to + range && window.scrollY >= to - range) {
                clearInterval(window.pageScroll);
                window.scrollTo(window.scrollX, to); //move window to final position to take care of rounding issues
            }
        }, 10);
    }
}

